/**
 * Convert measurement to a display value with no units
 * @param {number} value
 * @returns {string} the display value
 */
export function displayValueForUnitless(value) {
  return value || value == 0 ? value : "--";
}
